<template>
    <div class="flow-list-box">
      <list
            v-model="loading"
            :finished-text="finishedText"
            error-text="请求失败，点击重新加载"
            :error.sync="error"
            :finished="finished"
            @load="getProcessNodes">
        <div class="item-box" v-for="(item, index) in approveInfos" :key="item.taskId">
          <div class="item-left">
            {{index + 1}}
          </div>
          <div class="item-center">
            <div class="item-title">
              <span class="title-name van-ellipsis">{{ item.taskName }}</span>
              <!-- <span v-if="active == 'todo'">
                <span class="title-tag title-tag-error">{{ todostatusMap[item.taskType].text }}</span>
              </span> -->
              <span><!-- v-else -->
                <span class="title-tag"
                  :class="(item.formData && item.formData.reject == 'true') ? 'title-tag-error' : 'title-tag-success'"
                  v-if="item.taskType == 1">
                  {{ (item.formData && item.formData.reject == 'true') ? '审批不通过' : '审批通过' }}
                </span>
                <span v-else-if="item.taskType" class="title-tag title-tag-success">{{   downstatusMap[item.taskType].text }}</span>
              </span>
              <span class="title-time van-ellipsis">{{ item.username }}</span>
            </div>
            <div class="item-content">审批意见：{{ (item && item.formData && item.formData.opinions) ? item.formData.opinions : '' }}</div>
            <div class="item-subcontent" style="display: flex;justify-content: space-between;">
              <div>审批时间：{{ item.createTime }}</div>
              <div>滞留时间：{{ item.durationInMillis }}</div>
            </div>
          </div>
        </div>
      </list>
    </div>
</template>

<script>
import { List } from 'vant';
import application from '@api/application';
export default {
    name:'flowList',
    components: {
      List
    },
    props: {
      procInstId: {
        type: String,
        default() {
            return ''
        }
      }
    },
    data() {
        return {
          finishedText: '没有更多了',
          finished: false,
          loading: false,
          error: false,
          todostatusMap: {
              '1': { text: '待审批', status: 'warning' },
              '2': { text: '待处理', status: 'processing' },
              '3': { text: '待签名', status: 'processing' }
          },
          downstatusMap: {
              '1': { text: '审批', status: 'warning' },
              '2': { text: '处理', status: 'processing' },
              '3': { text: '签名', status: 'processing' }
          },
          approveInfos: [], // 审批流程信息
        }
    },
    created(){
    },
    computed: {
      active() {
        return this.$route.query.active
      },
      userInfo() {
        return localStorage.getItem("vuex") ? JSON.parse(localStorage.getItem("vuex")).user.userInfo : {}
      },
      currentId() {
        return this.procInstId
      }
    },
    methods: {
        getProcessNodes() {
          const params = { procInstId: this.currentId, pageNo: 1, pageSize: 100 }
          this.loading = true
          application.getDownList(params).then(res=> {
              this.loading = false
              if(res.code==200) {
                const data = res.data
                const userIds = data.map((d) => {
                    if (d.formData) {
                        d.formData = JSON.parse(d.formData)
                    }
                    return d.assignee
                })
                // console.log(userIds)
                application.getOrgEmployeesListBy({ userIds }).then((employees) => {
                    res.data.forEach((r) => {
                        employees.some((e) => {
                            if (e.userId === r.assignee) {
                                r.username = e.name
                                return true
                            }
                        })
                    })
                    // console.log(res.data)
                    this.approveInfos = res.data
                })
                // this.approveInfos = data
                if (data.length === 0) this.finishedText = '暂无数据'
                this.finished = true;
              } else {
                this.error = true
              }
          }).catch(err => {
            this.error = true
          })
        }
    },
    mounted() {
      // this.getProcessNodes()
    }
}
</script>

<style lang="scss">
  .flow-list-box{
 .item-box {
  display: flex;
  align-items: center;
  overflow: hidden;
  line-height: 2.4rem;
  font-size: 1.4rem;
  padding: 1rem 1.6rem;
  position: relative;
  &:active {
    background-color: #f2f3f5;
  }
  &::after {
    right: 0 !important;
    left: 0 !important;
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    right: 1.6rem;
    bottom: 0;
    left: 1.6rem;
    border-bottom: 0.1rem solid #ebedf0;
    -webkit-transform: scaleY(.5);
    transform: scaleY(.5);
  }
  .item-left {
    width: 3rem;
    height: 3rem;
    line-height: 3rem;
    text-align: center;
    color: #fff;
    font-size: 1.6rem;
    border-radius: 100%;
    background: #169BD5;
    margin-right: 1rem;
  }
  .item-center {
    flex: 1;
    overflow: hidden;
    .item-title {
      display: flex;
      .title-name {
        font-size: 1.6rem;
        flex: 1;
      }
      .title-tag {
        border-radius: 4px;
        font-size: 1.2rem;
        line-height: 2.4rem;
        padding: 0 0.6rem;
        margin-right: 1rem;
        height: 2.4rem;
      }
      .title-tag-success {
        color: #02A7F0;
        border: 1px solid #02a7f0;
        background: #02a7f019;
      }
      .title-tag-error {
        color: #F5222D;
        border: 1px solid #ffa39e;
        background: #fef0ef;
      }
      .title-time {
        max-width: 12rem;
        text-align: right;
        color: #999;
      }
    }
    .item-content {
      color: #999;
      word-break: break-all;
    }
    .item-subcontent {
      color: #999;
      font-size: 1.2rem;
    }
  }
  .item-right-icon {
    margin-left: 0.4rem;
    color: #969799;
  }
}
  }
</style>
